import { render, staticRenderFns } from "./Veroeffentlichungen.vue?vue&type=template&id=51c28a90&scoped=true"
import script from "./Veroeffentlichungen.vue?vue&type=script&lang=js"
export * from "./Veroeffentlichungen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c28a90",
  null
  
)

export default component.exports